var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUxDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 4.66667C9.18393 4.66667 9.33317 4.51743 9.33317 4.33333C9.33317 4.14924 9.18393 4 8.99984 4C8.81574 4 8.6665 4.14924 8.6665 4.33333C8.6665 4.51743 8.81574 4.66667 8.99984 4.66667Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 7.33317C11.8509 7.33317 12.0002 7.18393 12.0002 6.99984C12.0002 6.81574 11.8509 6.6665 11.6668 6.6665C11.4827 6.6665 11.3335 6.81574 11.3335 6.99984C11.3335 7.18393 11.4827 7.33317 11.6668 7.33317Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66683 5.33317C5.85092 5.33317 6.00016 5.18393 6.00016 4.99984C6.00016 4.81574 5.85092 4.6665 5.66683 4.6665C5.48273 4.6665 5.3335 4.81574 5.3335 4.99984C5.3335 5.18393 5.48273 5.33317 5.66683 5.33317Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 8.66667C4.51743 8.66667 4.66667 8.51743 4.66667 8.33333C4.66667 8.14924 4.51743 8 4.33333 8C4.14924 8 4 8.14924 4 8.33333C4 8.51743 4.14924 8.66667 4.33333 8.66667Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.3335C4.3335 1.3335 1.3335 4.3335 1.3335 8.00016C1.3335 11.6668 4.3335 14.6668 8.00016 14.6668C8.6175 14.6668 9.09883 14.1695 9.09883 13.5415C9.09883 13.2502 8.97883 12.9848 8.8075 12.7915C8.61416 12.5988 8.5155 12.3568 8.5155 12.0415C8.51297 11.8948 8.54001 11.749 8.59499 11.613C8.64998 11.4769 8.7318 11.3533 8.83556 11.2496C8.93933 11.1458 9.06292 11.064 9.19898 11.009C9.33504 10.954 9.48077 10.927 9.6275 10.9295H10.9582C12.9922 10.9295 14.6615 9.26083 14.6615 7.22683C14.6435 4.00816 11.6408 1.3335 8.00016 1.3335Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxDesign);
export default __webpack_public_path__ + "static/media/UX Design.e31ecff5d10e182ca24454414246a00d.svg";
export { ForwardRef as ReactComponent };